import React from 'react';
import { connect } from 'react-redux';

import { PAYMENT_THRESHOLD, PAYMENT_THRESHOLD_IBAN } from '../../../../constants';
import { PAYMENT_DELAY, PAYMENT_REQUEST_TYPE_EBON_ORDER } from '../../../../constants/payment';

import {
    getPaidAmountFormatted,
    isCurrentOnGoingPayementRequest,
    getPaymentRequestType,
    isFetching,
    getDateFormatted
} from '../../../../services/account/paymentrequest/ongoing/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import { InfoAccountComponent } from '../InfoAccountComponent';
import PaymentRequestFormComponent from './PaymentRequestFormComponent';
import ButtonComponent from '../../../../components/button/ButtonComponent';
import { withLoadingCondition } from '../../../loading/withLoadingCondition';

import './PaymentAreaComponent.scss';
import PaymentRequestEbonFormComponent from './PaymentRequestEbonFormComponent';
import { getValidatedAmount } from '../../../../services/account/gains/selector';

class PaymentAreaComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showIbanForm: false,
            showEbonForm: false
        };
    }

    handleIbanButtonClick = () => {
        this.setState({
            showIbanForm: !this.state.showIbanForm,
            showEbonForm: false
        });
    };
    handleBonButtonClick = () => {
        this.setState({
            showIbanForm: false,
            showEbonForm: !this.state.showEbonForm
        });
    };

    renderGetCashbackButton = () => {
        const { isCurrentOnGoingPayementRequest, validatedAmount } = this.props;
        const disabledIban = validatedAmount < PAYMENT_THRESHOLD_IBAN;
        const disabledEbon = validatedAmount < PAYMENT_THRESHOLD;

        if (!isCurrentOnGoingPayementRequest) {
            return (
                <div className="buttonWrapper">
                    <div className="button-margin">
                        <ButtonComponent
                            color="main"
                            disabled={disabledIban}
                            text={this.props.i18n.BUTTON_GET_GAIN_IBAN}
                            onClick={this.handleIbanButtonClick}
                        />
                        {disabledIban ? (
                            <p>
                                {this.props.i18n.TRESHOLD_MESSAGE} {PAYMENT_THRESHOLD_IBAN}€.
                            </p>
                        ) : (
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    this.props.i18n.TRESHOLD_MESSAGE_VALIDATE,
                                    PAYMENT_THRESHOLD_IBAN
                                )}
                            </p>
                        )}
                    </div>
                    <div className="button-margin">
                        <ButtonComponent
                            color="main"
                            disabled={disabledEbon}
                            text={this.props.i18n.BUTTON_GET_GAIN_EBON}
                            onClick={this.handleBonButtonClick}
                        />
                        {disabledEbon ? (
                            <p>
                                {this.props.i18n.TRESHOLD_MESSAGE} {PAYMENT_THRESHOLD}€.
                            </p>
                        ) : (
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    this.props.i18n.TRESHOLD_MESSAGE_VALIDATE,
                                    PAYMENT_THRESHOLD
                                )}
                            </p>
                        )}
                    </div>
                </div>
            );
        }
        return null;
    };

    renderCurrentPayment = () => {
        const {
            i18n,
            isCurrentOnGoingPayementRequest,
            paidAmountOnGoingPayementRequest,
            paymentRequestType,
            dateOnGoingPaymentRequest
        } = this.props;

        if (isCurrentOnGoingPayementRequest) {
            return (
                <div className="txtleft">
                    <h3>{i18n.PAYMENT_AREA}</h3>
                    {paymentRequestType === PAYMENT_REQUEST_TYPE_EBON_ORDER ? (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_EBON_ONGOING_1,
                                paidAmountOnGoingPayementRequest
                            )}
                            <br />
                            {i18n.PAYMENT_EBON_ONGOING_2}
                        </InfoAccountComponent>
                    ) : (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_ONGOING_1,
                                paidAmountOnGoingPayementRequest,
                                `<span class="bold">${dateOnGoingPaymentRequest}</span>`
                            )}
                            <br />
                            {i18n.PAYMENT_ONGOING_2}
                        </InfoAccountComponent>
                    )}
                </div>
            );
        }
        return null;
    };

    renderPaymentRequestFormComponent = () => {
        const { isCurrentOnGoingPayementRequest } = this.props;
        const { showIbanForm, showEbonForm } = this.state;

        if (!isCurrentOnGoingPayementRequest && showIbanForm) {
            return <PaymentRequestFormComponent />;
        }
        if (!isCurrentOnGoingPayementRequest && showEbonForm) {
            return <PaymentRequestEbonFormComponent />;
        }
    };

    renderArea = () => (
        <div className="txtcenter-mob bt-recup-cagnotte">
            {this.renderCurrentPayment()}
            {this.renderGetCashbackButton()}
            {this.renderPaymentRequestFormComponent()}
        </div>
    );

    render() {
        return (
            <div id="paymentAreaAnchor">
                {withLoadingCondition(this.props.isFetchingOnGoingPayment, this.renderArea)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        paidAmountOnGoingPayementRequest: getPaidAmountFormatted(state),
        isCurrentOnGoingPayementRequest: isCurrentOnGoingPayementRequest(state),
        dateOnGoingPaymentRequest: getDateFormatted(state, PAYMENT_DELAY),
        paymentRequestType: getPaymentRequestType(state),
        isFetchingOnGoingPayment: isFetching(state),
        validatedAmount: getValidatedAmount(state),
        user: state.account.user
    };
};

export default connect(mapStateToProps)(PaymentAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponent.js